<template>
    <div class="main-panel">
        <div class="content-wrapper dashboard-shell">
            <div class="cardplay bitacora-card horizontal-scrollable">
                <div class="row dashboard-header gx-3 gy-0 align-items-center mb-4">
                    <div class="col-lg-8 col-md-7">
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <span class="header-icon"><i class="fa-solid fa-notes-medical"></i></span>
                            <h2 class="dashboard-title mb-0">Bitácora</h2>
                        </div>
                        <p class="bitacora-subtitle mb-0">
                            Revisa la actividad por rango de fechas y exporta la información cuando la necesites.
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-5">
                        <div class="summary-chip summary-info d-flex align-items-center h-100">
                            <i class="fa-solid fa-circle-info me-2"></i>
                            <span>Selecciona un rango para filtrar los registros mostrados en la tabla.</span>
                        </div>
                    </div>
                </div>

                <div class="row g-3 mb-3">
                    <div class="col-md-6 col-sm-12">
                        <div class="summary-chip h-100 date-chip">
                            <p class="chip-label">Rango de fecha</p>
                            <VueDatePicker v-model="date" :range="true" rangeSeparator=" a " class="bitacora-datepicker" />
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <div class="summary-chip h-100 d-flex flex-column justify-content-center">
                            <p class="chip-label mb-2">Módulo activo</p>
                            <h5 class="chip-value mb-0">Bitácora por rango de fecha</h5>
                        </div>
                    </div>
                </div>

                <TablaPagos :key="`${date[0]}-${date[1]}-${pagoOption}`" :startDate="this.date[0]" :endDate="this.date[1]" />
            </div>
        </div>
    </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

import TablaPagos from './Tabla-Bitacora.vue';

export default {
    components: {
        VueDatePicker,
        TablaPagos
    },
    data() {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return {
            date: [today, today],
            ready: false,
            pagos: [],
            pagoOption: true,
        };

    },
    methods: {

    }

}
</script>

<style scoped>
.dashboard-shell {
    background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
    min-height: 100vh;
}

.cardplay {
    border-radius: 24px;
    border: 1px solid #e5e7eb;
    padding: 32px;
    background-color: #ffffff;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.dashboard-header {
    background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
    border-radius: 18px;
    color: #fff;
    padding: 16px 18px;
}

.header-icon {
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.18);
}

.dashboard-title {
    color: #fff;
    font-weight: 700;
    letter-spacing: 0.4px;
}

.bitacora-subtitle {
    color: #e5e7eb;
    font-size: 0.95rem;
}

.summary-chip {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 12px 14px;
}

.summary-info {
    color: #334155;
    font-size: 0.92rem;
}

.chip-label {
    margin-bottom: 4px;
    color: #64748b;
    font-size: 0.82rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.35px;
}

.chip-value {
    color: #0f172a;
    font-weight: 700;
}

.date-chip :deep(.dp__input_wrap) {
    width: 100%;
}

.date-chip :deep(.dp__input) {
    border-radius: 10px;
    border: 1px solid #d1d5db;
    font-size: 0.95rem;
}

@media (max-width: 768px) {
    .cardplay {
        padding: 20px;
    }
}
</style>
